import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import ShowRegistrationRequest from "src/components/panel/registration_requests/ShowRegistrationRequest";

const ShowRegistrationRequestView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("show_unregistration_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("show_unregistration_list_title")} 
        subtitle={t("show_unregistration_list_subtitle")}/>
        <ShowRegistrationRequest/>
      </Sidebar>
    </>
  );
};

export default ShowRegistrationRequestView;